import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { PaginationOptions, RequestConfig } from 'api/types';

export type AdviceRoomAuditTrailGetOptions = PaginationOptions;

export function adviceRoomAuditTrailApi(path: string) {
  return {
    path,
    GET: (params: AdviceRoomAuditTrailGetOptions, config?: RequestConfig) => {
      const { pageSize, pageNumber, ...rest } = params;

      return api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      });
    },
  };
}
